import { Navigate, Route, Routes } from "react-router-dom";

import MaintenanceControl from "./maintenanceControl";
import Monitoring from "./monitoring";
import DealershipAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import ServiceBayControl from "./serviceBayControl";
import Budgets from "./budgets";
import BudgetsKanbanPage from "./budgetsKanban";
import SupportPage from "../../support";
import SupportDetailsPage from "../../support/pages/details";
import NewSupportCallPage from "../../newSupportCall";

const DealershipRoutes = (props: any) => (
  <Routes>
    <Route
      path="/"
      element={<Navigate to="/dealership/maintenance-control" />}
    />
    <Route path="/monitoring" element={<Monitoring {...props} />} />
    <Route path="/maintenance-control" element={<MaintenanceControl {...props} />} />
    <Route path="/maintenance-monitoring" index element={<MaintenanceMonitoring {...props} />} />
    <Route
      path="/appointments/*"
      index
      element={<DealershipAppointmentsRoutes {...props} />}
    />
    <Route path="/service-bay-control" index element={<ServiceBayControl {...props} />} />
    <Route path="/budgets/*" element={<Budgets {...props} persona="dealership" />} />
    <Route path="/budgets-kanban" element={<BudgetsKanbanPage {...props} />} />
    <Route path="/support" element={<SupportPage {...props} />} />
    <Route path="/support/new-support-call" element={<NewSupportCallPage {...props} />} />
    <Route path="/support/details" element={<SupportDetailsPage {...props} />} />
  </Routes>
);

export default DealershipRoutes;
